/* JE68: global AJAX "Lägg i kundvagnen".
   Fångar ALLA formulär som postar till /cart/add (produktkort på startsida/kollektion,
   Utvald favorit, produktsidan, sök-kort) i capture-fas → varan läggs till direkt via
   AJAX, mini-cart-drawern renderas om och öppnas. Ingen sidladdning.
   Knappen får laddstate (spinner) → "✓ Tillagd" → återställs. Dubbelklick-skyddat. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function setCartCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    var txt = String(n);
    // Uppdatera/skapa badge i kundvagnslänkarna (desktop .je-cart-count + mobil .je-mcount).
    // OBS: skriv BARA vid faktisk ändring – setCartCount triggas av en MutationObserver
    // på <mini-cart>, och ovillkorliga skrivningar skulle ge en självtriggande loop.
    document.querySelectorAll('#header a[href$="/cart"]').forEach(function (link) {
      var badge = link.querySelector('.je-cart-count, .je-mcount');
      if (!badge && n > 0) {
        badge = document.createElement('span');
        badge.className = link.closest('.je-mhead') ? 'je-mcount' : 'je-cart-count';
        badge.textContent = txt;
        link.appendChild(badge);
        return;
      }
      if (badge) {
        if (n > 0) {
          if (badge.textContent !== txt) badge.textContent = txt;
          if (badge.hasAttribute('hidden')) badge.removeAttribute('hidden');
        } else { badge.remove(); }
      }
    });
    // Drawerns rubrik-badge ("Din kundvagn [n]") ligger i skalet som INTE omrenderas av temat
    var h4 = document.querySelector('.mini-cart-header h4');
    if (h4) {
      var tb = h4.querySelector('.je-cart-title-count');
      if (n > 0) {
        if (!tb) { tb = document.createElement('span'); tb.className = 'je-cart-title-count'; tb.textContent = txt; h4.appendChild(tb); }
        else if (tb.textContent !== txt) { tb.textContent = txt; }
      } else if (tb) { tb.remove(); }
    }
  }

  function syncFromMiniCart() {
    // Rakna fran DOM:en – mc.currentItemCount uppdateras BARA av add-flodet (renderContents),
    // inte av temats +/- och "Ta bort" (CartItems.updateQuantity) → vore inaktuellt har.
    var mc = document.querySelector('mini-cart');
    if (!mc) return;
    var n = 0;
    mc.querySelectorAll('[name="updates[]"]').forEach(function (inp) { n += parseInt(inp.value, 10) || 0; });
    setCartCount(n);
  }

  // Temat publicerar INGET event vid +/- eller "Ta bort" i drawern → observera innehållet.
  // renderContents satter currentItemCount fore observer-callbacken (microtask) kors.
  function watchMiniCart() {
    var mc = document.querySelector('mini-cart');
    if (!mc) return;
    new MutationObserver(syncFromMiniCart).observe(mc, { childList: true, subtree: true });
    syncFromMiniCart();
  }
  if (document.readyState !== 'loading') { watchMiniCart(); }
  else { document.addEventListener('DOMContentLoaded', watchMiniCart); }

  function startLoading(btn) {
    if (!btn) return null;
    var state = { html: btn.innerHTML, w: btn.getBoundingClientRect().width };
    btn.style.width = Math.ceil(state.w) + 'px'; // lås bredden så knappen inte "hoppar"
    btn.classList.add('je-adding');
    btn.setAttribute('aria-disabled', 'true');
    btn.innerHTML = '<span class="je-add-spin" aria-hidden="true"></span>';
    return state;
  }

  function restore(btn, state) {
    if (!btn || !state) return;
    btn.classList.remove('je-adding', 'je-added');
    btn.removeAttribute('aria-disabled');
    btn.style.width = '';
    btn.innerHTML = state.html;
  }

  function showSuccess(btn, state) {
    if (!btn || !state) return;
    btn.classList.remove('je-adding');
    btn.classList.add('je-added');
    btn.innerHTML = '✓ Tillagd';
    setTimeout(function () { restore(btn, state); }, 1500);
  }

  function handle(form, submitter) {
    var mc = window.miniCart;
    var btn = submitter || form.querySelector('[name="add"], [type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return; // dubbelklick-skydd
    var state = startLoading(btn);
    var fd = new FormData(form);
    var sections = (mc && mc.getSectionsToRender)
      ? mc.getSectionsToRender().map(function (s) { return s.section; }).filter(Boolean)
      : [];
    if (sections.length) { fd.append('sections', sections.join(',')); fd.append('sections_url', window.location.pathname); }

    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          restore(btn, state);
          var msg = res.data.description || res.data.message || 'Kunde inte lägga i kundvagnen.';
          var errWrap = form.querySelector('.product-form-error-message-wrapper');
          var errMsg = form.querySelector('.product-form-error-message');
          if (errMsg && errWrap) { errMsg.textContent = msg; errWrap.removeAttribute('hidden'); }
          else { window.alert(msg); }
          return;
        }
        if (mc && res.data.sections) { try { mc.renderContents(res.data); } catch (e) { /* noop */ } }
        if (mc && typeof mc.currentItemCount === 'number') { setCartCount(mc.currentItemCount); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'je-cart-add', cartData: res.data }); } catch (e) { /* noop */ }
        }
        showSuccess(btn, state);
        document.dispatchEvent(new CustomEvent('open-mini-cart', { detail: { opener: btn || form } }));
      })
      .catch(function () {
        // Nätverksfel → native POST som sista utväg (submit() triggar inte denna listener igen)
        restore(btn, state);
        form.submit();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || e.defaultPrevented) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1 && !form.matches('form[data-type="add-to-cart-form"]')) return;
    e.preventDefault();
    handle(form, e.submitter || null);
  }, true);

  window.JECartAdd = { setCartCount: setCartCount };
})();
